// extracted by mini-css-extract-plugin
export var columnItem = "_3x-3";
export var columnItemDraggable = "_3x-4";
export var dragHandle = "_3x-0";
export var dragHandleHovered = "_3x-1";
export var dropdown = "_3x-5";
export var dropdownContent = "_3x-7";
export var dropdownInner = "_3x-6";
export var filterDropdownHeader = "_3x-8";
export var icon = "_3x-2";
export var sectionDivider = "_3x-9";